var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import * as _ from 'lodash';
import { SwitchHelper } from '../../diagram/utils/switch/switch-helper';
import { IndicatorLightHelper } from '../../diagram/utils/indicator-light/indicator-light-helper';
import { SwitchType } from '../../diagram/utils/switch/switch-type';
import { IndicatorLightType } from '../../diagram/utils/indicator-light/indicator-light-type';
import { WordSwitchOperation } from '../../diagram/utils/switch/word-switch-operation';
import { WordExceptBHDataType, BitwiseDataType } from '../../core/variable/flag-data-type';
import { DataMonitorPermission } from '../../core/variable/data-monitor-permission';
import { VARIABLE_SERVICE } from '../../core/variable/variable.service';
import { calcMaxBitIndex } from '../../core/variable/data-type';
import { VariableName } from '../../core/variable/variable-name';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { FlagDataType } from '../../core/variable/flagDateType-enum';
var SwitchIndicatorLightBasicInfoComponent = /** @class */ (function (_super) {
    __extends(SwitchIndicatorLightBasicInfoComponent, _super);
    function SwitchIndicatorLightBasicInfoComponent(injector, variableService) {
        var _this = _super.call(this, injector) || this;
        _this.variableService = variableService;
        _this.useSwitch = false;
        _this.useSwitchChange = new EventEmitter();
        _this.switchBitIndexChangeEvent = new EventEmitter();
        _this.lightBitIndexChangeEvent = new EventEmitter();
        _this.switchVariableChangeEvent = new EventEmitter();
        _this.lightVariableChangeEvent = new EventEmitter();
        _this.isSwitchBitwiseIndex = false;
        _this.switchBitIndex = 0;
        _this.switchMaxBitIndex = 31;
        _this.lightBitIndex = 0;
        _this.lightMaxBitIndex = 31;
        _this.isLightBitwiseIndex = false;
        _this.useIndicatorLight = false;
        _this.useIndicatorLightChange = new EventEmitter();
        _this.switchType = SwitchType;
        _this.indicatorLightType = IndicatorLightType;
        _this.bitDataType = FlagDataType.Bool;
        _this.bitwiseDataType = BitwiseDataType;
        _this.wordDataType = WordExceptBHDataType;
        _this.writeModel = DataMonitorPermission.Write;
        _this.readModel = DataMonitorPermission.Read;
        _this.switchTypes = SwitchHelper.getSwitchTypes();
        _this.indicatorLightTypes = IndicatorLightHelper.getIndicatorLightTypes();
        return _this;
    }
    Object.defineProperty(SwitchIndicatorLightBasicInfoComponent.prototype, "switchSettings", {
        get: function () {
            return this._switchSettings;
        },
        set: function (v) {
            if (this._switchSettings === v) {
                return;
            }
            this._switchSettings = v;
            var settings = this._switchSettings.settings;
            if (settings) {
                this.isSwitchBitwiseIndex = settings.isBitwiseIndex ? settings.isBitwiseIndex : false;
                if (this.switchSettings.type === SwitchType.Bit && !this.isSwitchBitwiseIndex) {
                    this.initBitSwitchVariable(settings);
                }
                else if (this.switchSettings.type === SwitchType.Word) {
                    this.initWordSwitchVariable(settings);
                }
                else if (this.isSwitchBitwiseIndex && this.switchSettings.type === SwitchType.Bit) {
                    this.switchBitIndex = settings.bitIndex ? settings.bitIndex : 0;
                    this.initeSwitchBitWishVariable(settings);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwitchIndicatorLightBasicInfoComponent.prototype, "indicatorLightSettings", {
        get: function () {
            return this._indicatorLightSettings;
        },
        set: function (v) {
            if (this._indicatorLightSettings === v) {
                return;
            }
            this._indicatorLightSettings = v;
            var settings = this._indicatorLightSettings.settings;
            if (settings) {
                this.isLightBitwiseIndex = settings.isBitwiseIndex ? settings.isBitwiseIndex : false;
                if (this._indicatorLightSettings.type === IndicatorLightType.Bit && !this.isLightBitwiseIndex) {
                    this.initeBitLightVariable(settings);
                }
                else if (this._indicatorLightSettings.type === IndicatorLightType.Word) {
                    this.initWordLightVariable(settings);
                }
                else if (this._indicatorLightSettings.type === IndicatorLightType.Bit && this.isLightBitwiseIndex) {
                    this.lightBitIndex = settings.bitIndex ? settings.bitIndex : 0;
                    this.initLightBitWiseVariable(settings);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwitchIndicatorLightBasicInfoComponent.prototype, "currentBitSwitchVariableId", {
        get: function () {
            return this._currentBitSwitchVariableId;
        },
        set: function (v) {
            if (VariableName.equals(v, this._currentBitSwitchVariableId)) {
                return;
            }
            this._currentBitSwitchVariableId = v;
            this.switchVariableChanged(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwitchIndicatorLightBasicInfoComponent.prototype, "currentSwitchBitwiseVariableId", {
        get: function () {
            return this._currentSwitchBitwiseVariableId;
        },
        set: function (v) {
            var _this = this;
            if (VariableName.equals(v, this._currentSwitchBitwiseVariableId)) {
                return;
            }
            this._currentSwitchBitwiseVariableId = v;
            if (v) {
                this.variableService.findVariable(v)
                    .subscribe(function (variable) {
                    _this.setSwitchMaxBitIndex(variable.dataType);
                });
            }
            this.switchVariableChanged(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwitchIndicatorLightBasicInfoComponent.prototype, "currentWordSwitchVariableId", {
        get: function () {
            return this._currentWordSwitchVariableId;
        },
        set: function (v) {
            if (VariableName.equals(v, this._currentWordSwitchVariableId)) {
                return;
            }
            this._currentWordSwitchVariableId = v;
            this.switchVariableChanged(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwitchIndicatorLightBasicInfoComponent.prototype, "currentBitLightVariableId", {
        get: function () {
            return this._currentBitLightVariableId;
        },
        set: function (v) {
            if (VariableName.equals(v, this._currentBitLightVariableId)) {
                return;
            }
            this._currentBitLightVariableId = v;
            this.lightVariableChanged(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwitchIndicatorLightBasicInfoComponent.prototype, "currentLightBitwiseVariableId", {
        get: function () {
            return this._currentLightBitwiseVariableId;
        },
        set: function (v) {
            var _this = this;
            if (VariableName.equals(v, this.currentLightBitwiseVariableId)) {
                return;
            }
            this._currentLightBitwiseVariableId = v;
            if (v) {
                this.variableService.findVariable(v)
                    .subscribe(function (variable) {
                    _this.setLightMaxBitIndex(variable.dataType);
                });
            }
            this.lightVariableChanged(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwitchIndicatorLightBasicInfoComponent.prototype, "currentWordLightVariableId", {
        get: function () {
            return this._currentWordLightVariableId;
        },
        set: function (v) {
            if (VariableName.equals(v, this._currentWordLightVariableId)) {
                return;
            }
            this._currentWordLightVariableId = v;
            this.lightVariableChanged(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwitchIndicatorLightBasicInfoComponent.prototype, "operandName", {
        get: function () {
            switch (this.switchSettings.settings.operation) {
                case WordSwitchOperation.Add: return this.lc('Addition');
                case WordSwitchOperation.Subtract: return this.lc('Subtraction');
                case WordSwitchOperation.SetConstant: return this.lc('Constant');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwitchIndicatorLightBasicInfoComponent.prototype, "switchOperations", {
        get: function () {
            return SwitchHelper.getSwitchOperations(this.switchSettings.type);
        },
        enumerable: true,
        configurable: true
    });
    SwitchIndicatorLightBasicInfoComponent.prototype.hasOperand = function () {
        return this.useSwitch && this.switchSettings.type === SwitchType.Word;
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.setLightMaxBitIndex = function (dataType) {
        if (dataType) {
            this.lightMaxBitIndex = calcMaxBitIndex(dataType);
            this.indicatorLightSettings.settings.dataType = dataType;
            this.lightVariableChangeEvent.emit();
        }
        else {
            delete this.indicatorLightSettings.settings.dataType;
        }
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.setSwitchMaxBitIndex = function (dataType) {
        if (dataType) {
            this.switchMaxBitIndex = calcMaxBitIndex(dataType);
            this.switchSettings.settings.dataType = dataType;
        }
        else {
            delete this.switchSettings.settings.dataType;
        }
        this.switchVariableChangeEvent.emit();
    };
    // bit
    SwitchIndicatorLightBasicInfoComponent.prototype.changeUseSwitch = function () {
        this.useSwitch = !this.useSwitch;
        this.useSwitchChange.emit(this.useSwitch);
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.changeSwitchType = function () {
        this.switchSettings.settings.operation = 0;
        if (SwitchType.Bit === this.switchSettings.type) {
            delete this.switchSettings.settings['operand'];
        }
        else {
            this.switchSettings.settings.operand = 1;
            this.switchSettings.settings.isBitwiseIndex = false;
        }
        delete this.switchSettings.settings['variableName'];
        delete this.switchSettings.settings['variableGroupName'];
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.switchVariableChanged = function (v) {
        if (v) {
            this.switchSettings.settings.variableName = v.name;
            this.switchSettings.settings.variableVersion = v.variableVersion;
            this.switchSettings.settings.isBitwiseIndex = this.isSwitchBitwiseIndex;
            if (this.isSwitchBitwiseIndex) {
                this.switchSettings.settings.bitIndex = this.switchBitIndex;
            }
            else {
                delete this.switchSettings.settings.bitIndex;
            }
            delete this.switchSettings.settings.dataSourceCode;
            delete this.switchSettings.settings.variableGroupName;
        }
        else {
            this.switchSettings.settings.isBitwiseIndex = false;
            this.switchSettings.settings.variableName = '';
            this.switchSettings.settings.variableVersion = undefined;
            delete this.switchSettings.settings.dataSourceCode;
            delete this.switchSettings.settings.variableGroupName;
        }
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.changeSwitchBitwiseIndex = function () {
        this.isSwitchBitwiseIndex = !this.isSwitchBitwiseIndex;
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.changeSwitchBitIndex = function (ev) {
        if (this.switchBitIndex !== null) {
            this.switchBitIndex = Math.floor(this.switchBitIndex);
        }
        this.switchSettings.settings.bitIndex = this.switchBitIndex;
        this.switchBitIndexChangeEvent.emit();
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.isSwitchBitIndexWithinScope = function () {
        return this.isBitIndexWithinScope(this.switchBitIndex, this.switchMaxBitIndex);
    };
    // light
    SwitchIndicatorLightBasicInfoComponent.prototype.changeUseIndicatorLight = function () {
        this.useIndicatorLight = !this.useIndicatorLight;
        this.useIndicatorLightChange.emit(this.useIndicatorLight);
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.changeIndicatorLightType = function () {
        if (this.indicatorLightSettings.type !== IndicatorLightType.Bit) {
            this.switchSettings.settings.isBitwiseIndex = false;
        }
        delete this.indicatorLightSettings.settings['variableName'];
        delete this.indicatorLightSettings.settings['variableGroupName'];
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.lightVariableChanged = function (v) {
        if (v) {
            this.indicatorLightSettings.settings.variableName = v.name;
            this.indicatorLightSettings.settings.isBitwiseIndex = this.isLightBitwiseIndex;
            this.indicatorLightSettings.settings.variableVersion = v.variableVersion;
            if (this.isLightBitwiseIndex) {
                this.indicatorLightSettings.settings.bitIndex = this.lightBitIndex;
            }
            else {
                delete this.indicatorLightSettings.settings.bitIndex;
            }
            delete this.switchSettings.settings.dataSourceCode;
            delete this.switchSettings.settings.variableGroupName;
        }
        else {
            this.indicatorLightSettings.settings.isBitwiseIndex = false;
            this.indicatorLightSettings.settings.variableName = '';
            this.indicatorLightSettings.settings.variableVersion = undefined;
            delete this.switchSettings.settings.dataSourceCode;
            delete this.switchSettings.settings.variableGroupName;
        }
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.changeLightBitwiseIndex = function () {
        this.isLightBitwiseIndex = !this.isLightBitwiseIndex;
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.changeLightBitIndex = function (ev) {
        if (this.lightBitIndex !== null) {
            this.lightBitIndex = Math.floor(this.lightBitIndex);
        }
        this.indicatorLightSettings.settings.bitIndex = this.lightBitIndex;
        this.lightBitIndexChangeEvent.emit();
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.isLightBitIndexWithinScope = function () {
        return this.isBitIndexWithinScope(this.lightBitIndex, this.lightMaxBitIndex);
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.isBitIndexWithinScope = function (bitIndex, maxBitIndex) {
        if (!_.isNil(bitIndex) && bitIndex >= 0 && bitIndex <= maxBitIndex) {
            return false;
        }
        return true;
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.initBitSwitchVariable = function (settings) {
        var _this = this;
        if (settings.variableVersion) {
            this._currentBitSwitchVariableId = VariableName.tryParse(settings.variableName, settings.variableVersion);
        }
        else if (!_.isNil(settings.dataSourceCode)) {
            this.variableService.getVariableName(settings.dataSourceCode, settings.variableName, settings.variableGroupName).subscribe(function (value) {
                _this._currentBitSwitchVariableId = value;
            });
        }
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.initWordSwitchVariable = function (settings) {
        var _this = this;
        if (settings.variableVersion) {
            this._currentWordSwitchVariableId = VariableName.tryParse(settings.variableName, settings.variableVersion);
        }
        else if (!_.isNil(settings.dataSourceCode)) {
            this.variableService.getVariableName(settings.dataSourceCode, settings.variableName, settings.variableGroupName).subscribe(function (value) {
                _this._currentWordSwitchVariableId = value;
            });
        }
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.initeSwitchBitWishVariable = function (settings) {
        var _this = this;
        if (settings.variableVersion) {
            this._currentSwitchBitwiseVariableId = VariableName.tryParse(settings.variableName, settings.variableVersion);
            this.findSwitchBitWishVariable();
        }
        else if (!_.isNil(settings.dataSourceCode)) {
            this.variableService.getVariableName(settings.dataSourceCode, settings.variableName, settings.variableGroupName).subscribe(function (value) {
                _this._currentSwitchBitwiseVariableId = value;
                _this.findSwitchBitWishVariable();
            });
        }
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.findSwitchBitWishVariable = function () {
        var _this = this;
        if (this._currentSwitchBitwiseVariableId) {
            this.variableService.findVariable(this._currentSwitchBitwiseVariableId)
                .subscribe(function (variable) {
                _this.setSwitchMaxBitIndex(variable.dataType);
            });
        }
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.initeBitLightVariable = function (settings) {
        var _this = this;
        if (settings.variableVersion) {
            this._currentBitLightVariableId = VariableName.tryParse(settings.variableName, settings.variableVersion);
        }
        else if (!_.isNil(settings.dataSourceCode)) {
            this.variableService.getVariableName(settings.dataSourceCode, settings.variableName, settings.variableGroupName).subscribe(function (value) {
                _this._currentBitLightVariableId = value;
            });
        }
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.initWordLightVariable = function (settings) {
        var _this = this;
        if (settings.variableVersion) {
            this._currentWordLightVariableId = VariableName.tryParse(settings.variableName, settings.variableVersion);
        }
        else if (!_.isNil(settings.dataSourceCode)) {
            this.variableService.getVariableName(settings.dataSourceCode, settings.variableName, settings.variableGroupName).subscribe(function (value) {
                _this._currentWordLightVariableId = value;
            });
        }
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.initLightBitWiseVariable = function (settings) {
        var _this = this;
        if (settings.variableVersion) {
            this._currentLightBitwiseVariableId = VariableName.tryParse(settings.variableName, settings.variableVersion);
            this.findWordBitwiseVariable();
        }
        else if (!_.isNil(settings.dataSourceCode)) {
            this.variableService.getVariableName(settings.dataSourceCode, settings.variableName, settings.variableGroupName).subscribe(function (value) {
                _this._currentLightBitwiseVariableId = value;
                _this.findWordBitwiseVariable();
            });
        }
    };
    SwitchIndicatorLightBasicInfoComponent.prototype.findWordBitwiseVariable = function () {
        var _this = this;
        if (this._currentLightBitwiseVariableId) {
            this.variableService.findVariable(this._currentLightBitwiseVariableId)
                .subscribe(function (variable) {
                _this.setLightMaxBitIndex(variable.dataType);
            });
        }
    };
    __decorate([
        Input()
    ], SwitchIndicatorLightBasicInfoComponent.prototype, "configureId", void 0);
    __decorate([
        Input()
    ], SwitchIndicatorLightBasicInfoComponent.prototype, "useSwitch", void 0);
    __decorate([
        Output()
    ], SwitchIndicatorLightBasicInfoComponent.prototype, "useSwitchChange", void 0);
    __decorate([
        Output()
    ], SwitchIndicatorLightBasicInfoComponent.prototype, "switchBitIndexChangeEvent", void 0);
    __decorate([
        Output()
    ], SwitchIndicatorLightBasicInfoComponent.prototype, "lightBitIndexChangeEvent", void 0);
    __decorate([
        Output()
    ], SwitchIndicatorLightBasicInfoComponent.prototype, "switchVariableChangeEvent", void 0);
    __decorate([
        Output()
    ], SwitchIndicatorLightBasicInfoComponent.prototype, "lightVariableChangeEvent", void 0);
    __decorate([
        Input()
    ], SwitchIndicatorLightBasicInfoComponent.prototype, "switchSettings", null);
    __decorate([
        Input()
    ], SwitchIndicatorLightBasicInfoComponent.prototype, "useIndicatorLight", void 0);
    __decorate([
        Output()
    ], SwitchIndicatorLightBasicInfoComponent.prototype, "useIndicatorLightChange", void 0);
    __decorate([
        Input()
    ], SwitchIndicatorLightBasicInfoComponent.prototype, "indicatorLightSettings", null);
    SwitchIndicatorLightBasicInfoComponent = __decorate([
        Component({
            selector: 'switch-indicator-light-basic-info',
            styles: [".mt-checkbox-outline { margin-bottom: 5px } .padding-top-10 { padding-top: 10px; } .labelWidth { width: 180px; } .variable-combo-padding { padding-top: 6px; padding-bottom: 6px; } .radio-title { font-size: 14px; color: #333333; } .warn-color { color: red; margin-left: 105px; } .bitwise-label { width: 100px; } .bitwise-variable { width: calc(100% - 205px); } .bitwise-bitIndex { width: 90px; } .point { height: 30px; float: left; width: 10px; text-align: center; } .design-nav-link { .nav.nav-tabs { .nav-link { color: #666 !important; border-bottom: 1px solid transparent; } .active{ border-color: #fff; color: #3695ff !important; border-bottom: 1px solid #3695ff; } } }"],
            template: "<div class=\"fe-modal-body\"  provide-parent-forms> <div class=\"modal-switch-indicator\"> <div class=\"fe-option-head\"> <label for=\"useSwitch\"> <input type=\"checkbox\" id=\"useSwitch\" [checked]=\"useSwitch\" (change)=\"changeUseSwitch()\" /> <span>{{lc('UseSwitch')}}</span> </label> </div> <div class=\"fe-modal-content\" *ngIf=\"useSwitch\"> <div class=\"fe-radio-select-header\"> <label *ngFor=\"let type of switchTypes\"> <input type=\"radio\" name=\"switchTypeRadio\" [value]=\"type.key\" [(ngModel)]=\"switchSettings.type\" (change)=\"changeSwitchType()\" /> <span class=\"radio-title\">{{lc(type.name)}}</span> </label> </div> <div class=\"fe-radio-select-body clearfix\"> <div class=\"fe-option-head\" *ngIf=\"switchSettings.type === switchType.Bit\"> <label for=\"isSwitchBitwiseIndex\"> <input type=\"checkbox\" id=\"isSwitchBitwiseIndex\" [checked]=\"isSwitchBitwiseIndex\" (change)=\"changeSwitchBitwiseIndex()\" /> <span>{{lc('UseWordRegister')}}</span> </label> </div> <div class=\"fe-option-body clearfix margin-top-5\"> <div class=\"fe-transverse-label clearfix margin-top-5\"> <div class=\"fe-transverse-title\"> {{lc(\"ExecuteSetting\")}}： </div> <div class=\"fe-transverse-component\"> <ng-select name=\"ngSelect\" [clearable]=\"false\" [(ngModel)]=\"switchSettings.settings.operation\" [items]=\"switchOperations\" bindLabel=\"name\" bindValue=\"key\" [loadingText]=\"l('Loading')\" [notFoundText]=\"l('NoData')\"> <ng-template ng-label-tmp let-item=\"item\" let-index=\"index\"> {{lc(item.name)}} </ng-template> <ng-template ng-option-tmp let-item=\"item\" let-index=\"index\"> {{lc(item.name)}} </ng-template> </ng-select> </div> </div> <div class=\"fe-transverse-label clearfix margin-top-5\" *ngIf=\"hasOperand()\"> <div class=\"fe-transverse-title\"> {{operandName}}： </div> <input type=\"number\" class=\"fe-transverse-input\" [(ngModel)]=\"switchSettings.settings.operand\" name=\"number\"> </div> <div class=\"fe-transverse-label clearfix margin-top-5\" *ngIf=\"switchSettings.type === switchType.Bit && !isSwitchBitwiseIndex\"> <div class=\"fe-transverse-title\"> {{lc(\"VariableName\")}}： </div> <div class=\"fe-transverse-component\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentBitSwitchVariableId\" [dataType]=\"bitDataType\" [readWriteModel]=\"writeModel\"></variable-selector> </div> </div> <div class=\"fe-transverse-label clearfix margin-top-5\" *ngIf=\"switchSettings.type === switchType.Bit && isSwitchBitwiseIndex\"> <div class=\"fe-transverse-title  bitwise-label\"> {{lc(\"VariableName\")}}： </div> <div class=\"fe-transverse-component\" [ngClass]=\"currentSwitchBitwiseVariableId ? 'bitwise-variable' : ''\"> <variable-selector [configureId]=\"configureId\"  [(currentVariableId)]=\"currentSwitchBitwiseVariableId\" [dataType]=\"bitwiseDataType\" [readWriteModel]=\"writeModel\"></variable-selector> </div> <div class=\"point\" *ngIf=\"currentSwitchBitwiseVariableId\">.</div> <input type=\"number\" class=\"bitwise-bitIndex\" [(ngModel)]=\"switchBitIndex\" name=\"switchBitIndex\" *ngIf=\"currentSwitchBitwiseVariableId\" (keyup)=\"changeSwitchBitIndex($event)\" (change)=\"changeSwitchBitIndex($event)\" required> </div> <div class=\"fe-transverse-label clearfix margin-top-5\" *ngIf=\"switchSettings.type === switchType.Word\"> <div class=\"fe-transverse-title\"> {{lc(\"VariableName\")}}： </div> <div class=\"fe-transverse-component\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentWordSwitchVariableId\" [dataType]=\"wordDataType\" [readWriteModel]=\"writeModel\"></variable-selector> </div> </div> <div class=\"fe-transverse-label warn-color\" *ngIf=\"(switchBitIndex < 0 || switchBitIndex > switchMaxBitIndex) && switchSettings.type === switchType.Bit && isSwitchBitwiseIndex\"> {{lc(\"PleaseEnterDigits\",switchMaxBitIndex)}} </div> </div> </div> </div> </div> <div class=\"modal-switch-indicator\"> <div class=\"fe-option-head\"> <label for=\"useIndicatorLight\"> <input type=\"checkbox\" id=\"useIndicatorLight\" [checked]=\"useIndicatorLight\" (change)=\"changeUseIndicatorLight()\" /> <span class=\"switch-text\">{{lc('UseIndicatorLight')}}</span> </label> </div> <div class=\"fe-modal-content\" *ngIf=\"useIndicatorLight\"> <div class=\"fe-radio-select-header\"> <label *ngFor=\"let type of indicatorLightTypes\"> <input type=\"radio\" name=\"indicator\" [value]=\"type.key\" [(ngModel)]=\"indicatorLightSettings.type\" (change)=\"changeIndicatorLightType()\"/> <span class=\"radio-title\">{{lc(type.name)}}</span> </label> </div> <div class=\"fe-radio-select-body\"> <div class=\"fe-option-head\" *ngIf=\"indicatorLightSettings.type === indicatorLightType.Bit\"> <label for=\"isLightBitwiseIndex\"> <input type=\"checkbox\" id=\"isLightBitwiseIndex\" [checked]=\"isLightBitwiseIndex\" (change)=\"changeLightBitwiseIndex()\" /> <span>{{lc('UseWordRegister')}}</span> </label> </div> <div class=\"fe-option-body clearfix\"> <div class=\"fe-transverse-label\" *ngIf=\"indicatorLightSettings.type === indicatorLightType.Bit && !isLightBitwiseIndex\"> <div class=\"fe-transverse-title\"> {{lc(\"VariableName\")}}： </div> <div class=\"fe-transverse-component\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentBitLightVariableId\" [dataType]=\"bitDataType\" [readWriteModel]=\"readModel\"></variable-selector> </div> </div> <div class=\"fe-transverse-label\" *ngIf=\"indicatorLightSettings.type === indicatorLightType.Bit && isLightBitwiseIndex\"> <div class=\"fe-transverse-title bitwise-label\"> {{lc(\"VariableName\")}}： </div> <div class=\"fe-transverse-component\" [ngClass]=\"currentLightBitwiseVariableId ? 'bitwise-variable' : ''\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentLightBitwiseVariableId\" [dataType]=\"bitwiseDataType\" [readWriteModel]=\"readModel\"></variable-selector> </div> <div class=\"point\" *ngIf=\"currentLightBitwiseVariableId\">.</div> <input type=\"number\" class=\"bitwise-bitIndex\" [(ngModel)]=\"lightBitIndex\" name=\"lightBitIndex\" *ngIf=\"currentLightBitwiseVariableId\" (keyup)=\"changeLightBitIndex($event)\" (change)=\"changeLightBitIndex($event)\" required> </div> <div class=\"fe-transverse-label\" *ngIf=\"indicatorLightSettings.type === indicatorLightType.Word\"> <div class=\"fe-transverse-title\"> {{lc(\"VariableName\")}}： </div> <div class=\"fe-transverse-component\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentWordLightVariableId\" [dataType]=\"wordDataType\" [readWriteModel]=\"readModel\"></variable-selector> </div> </div> <div class=\"fe-transverse-label warn-color\" *ngIf=\"(lightBitIndex < 0 || lightBitIndex > lightMaxBitIndex) && indicatorLightSettings.type === indicatorLightType.Bit && isLightBitwiseIndex\"> {{lc(\"PleaseEnterDigits\",lightMaxBitIndex)}}  </div> </div> </div> </div> </div> </div>"
        }),
        __param(1, Inject(VARIABLE_SERVICE))
    ], SwitchIndicatorLightBasicInfoComponent);
    return SwitchIndicatorLightBasicInfoComponent;
}(ConfigureComponentBase));
export { SwitchIndicatorLightBasicInfoComponent };
